// extracted by mini-css-extract-plugin
export default {"productDescription":"Y2-z","featuredDescription":"Z2-z","description":"_2-z","more":"a3-z","brandLogo":"b3-z","descriptionSku":"c3-z"};